import { useEffect, useRef } from 'react';
import { appNav } from './nav';

/**
 * Пока `active` — экран открыт и на него есть запись в истории браузера
 * (призрак без адреса); системная «назад» позовёт `onPop`, и экран должен
 * закрыться сам. Закрыли экран иначе — запись снимается при уходе `active`
 * в false.
 */
export function useBackEntry(active: boolean, onPop: () => void) {
  const cb = useRef(onPop);
  cb.current = onPop;
  useEffect(() => {
    if (!active) return;
    const nav = appNav();
    const id = nav.entry(() => cb.current());
    return () => nav.remove(id);
  }, [active]);
}
